import { useEffect } from "react";
import { ArrowRight } from "lucide-react";

export const CALENDLY_URL = "https://calendly.com/xycjustin";

const openPopup = (e) => {
  e?.preventDefault?.();
  if (window.Calendly && typeof window.Calendly.initPopupWidget === "function") {
    window.Calendly.initPopupWidget({ url: CALENDLY_URL });
    return false;
  }
  window.open(CALENDLY_URL, "_blank", "noopener,noreferrer");
};

export const CalendlyButton = ({
  children = "Book a Free Sleep Assessment",
  variant = "primary",
  className = "",
  testId = "calendly-button",
  withArrow = true,
}) => {
  const base =
    "inline-flex items-center gap-2 font-medium transition-all duration-200 cursor-pointer rounded-full";
  const variants = {
    primary:
      "bg-brand-600 text-white hover:bg-brand-700 px-7 py-3.5 text-[15px] shadow-[0_2px_8px_rgba(79,70,229,0.22)] hover:shadow-[0_4px_14px_rgba(124,58,237,0.30)] hover:bg-gradient-to-r hover:from-brand-600 hover:to-violet-600",
    outline:
      "bg-white border border-ink-200 text-ink-900 hover:border-brand-600 hover:text-brand-600 px-7 py-3.5 text-[15px]",
    ghost:
      "text-brand-600 hover:text-violet-600 px-3 py-2 text-sm",
    pill:
      "bg-brand-600 text-white hover:bg-brand-700 px-5 py-2.5 text-sm shadow-[0_2px_8px_rgba(79,70,229,0.22)]",
  };
  return (
    <button
      type="button"
      onClick={openPopup}
      data-testid={testId}
      className={`group ${base} ${variants[variant]} ${className}`}
    >
      {children}
      {withArrow && (
        <ArrowRight
          size={16}
          className="transition-transform group-hover:translate-x-0.5"
        />
      )}
    </button>
  );
};

// Inline widget embed for Contact page (light theme)
export const CalendlyInline = ({ height = 720 }) => {
  useEffect(() => {
    const tryInit = () => {
      if (
        window.Calendly &&
        typeof window.Calendly.initInlineWidget === "function"
      ) {
        const target = document.getElementById("calendly-inline-widget");
        if (target && !target.dataset.initialized) {
          target.innerHTML = "";
          window.Calendly.initInlineWidget({
            url: `${CALENDLY_URL}?hide_landing_page_details=1&hide_gdpr_banner=1&background_color=ffffff&text_color=0F172A&primary_color=2563EB`,
            parentElement: target,
          });
          target.dataset.initialized = "true";
        }
        return true;
      }
      return false;
    };
    if (!tryInit()) {
      const t = setInterval(() => {
        if (tryInit()) clearInterval(t);
      }, 200);
      return () => clearInterval(t);
    }
  }, []);

  return (
    <div
      id="calendly-inline-widget"
      data-testid="calendly-inline-widget"
      className="rounded-2xl overflow-hidden border border-ink-200 bg-white shadow-sm"
      style={{ minWidth: "320px", height }}
    />
  );
};

export default CalendlyButton;
